import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { siteApi, mediaUrl } from "../api";
import { PageHero, Empty } from "./parts";

export default function GalleryPage() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState("all");
  const [open, setOpen] = useState(null);
  useEffect(() => { siteApi.get("/website/gallery").then((r) => setData(r.data)).catch(() => setData({ categories: [], images: [] })); }, []);
  const images = (data?.images || []).filter((i) => active === "all" || i.category_id === active);
  const cats = data?.categories || [];
  return (
    <>
      <PageHero eyebrow="Galerie" title="Einblicke in unseren Salon" />
      <div className="max-w-6xl mx-auto px-5 py-12 sm:py-16">
        {cats.length > 0 && (
          <div className="flex gap-2 overflow-x-auto vs-hide-scrollbar pb-2 mb-8" data-testid="gallery-filter">
            {[{ id: "all", name: "Alle" }, ...cats].map((c) => (
              <button key={c.id} data-testid={`gallery-filter-${c.id}`} onClick={() => setActive(c.id)} className={`shrink-0 px-4 py-2 rounded-full text-sm border transition-colors ${active === c.id ? "bg-[var(--brand-primary)] text-white border-[var(--brand-primary)]" : "bg-white text-stone-700 border-stone-200 hover:border-[var(--brand-primary)]"}`}>{c.name}</button>
            ))}
          </div>
        )}
        {data && images.length === 0 && <Empty>Noch keine Bilder in der Galerie.</Empty>}
        <div className="columns-2 md:columns-3 gap-3 sm:gap-4 [&>*]:mb-3 sm:[&>*]:mb-4" data-testid="gallery-grid">
          {images.map((g) => (
            <button key={g.id} onClick={() => setOpen(g)} className="block w-full break-inside-avoid rounded-xl overflow-hidden group relative" data-testid={`gallery-item-${g.id}`}>
              <img src={mediaUrl(g.media_id)} alt={g.title || ""} loading="lazy" className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
              {g.title && <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent text-white text-sm p-3 text-left">{g.title}</span>}
            </button>
          ))}
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setOpen(null)} data-testid="gallery-lightbox">
          <button className="absolute top-4 right-4 text-white p-2" aria-label="Schließen" data-testid="gallery-lightbox-close"><X className="h-6 w-6" /></button>
          <figure className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={mediaUrl(open.media_id)} alt={open.title || ""} className="w-full max-h-[80vh] object-contain" />
            {(open.title || open.description) && <figcaption className="text-stone-200 text-sm mt-3 text-center"><strong>{open.title}</strong>{open.description ? ` — ${open.description}` : ""}</figcaption>}
          </figure>
        </div>
      )}
    </>
  );
}
